// @ts-nocheck
import * as React from 'react';
import styled from 'styled-components';
import T from 'aegisv2/Text';
import { Query } from '@apollo/client/react/components';

import { useTranslation, useIsBrazil } from '@crehana/i18n';
import { transformData } from '@crehana/utils';

import GetLeadSection from 'Jsx/ResourceDetail/components/GetLeadSection';

import { useMe } from 'Jsx/ContextApis/AuthContext';

import getCountryPrefix from 'Utils/getCountryPrefix';

import { ResourceProps } from '../types';
import ResourcesQuery from '../graphql/Resources.graphql';
import localesEs from '../i18n/localeEs';

import ResourceCard from './ResourceCard';

type RelatedContentProps = {
  category: string;
  resourceCategory: {
    name: string;
    slug: string;
  };
};

type ResourcesQueryVariables = {
  first: number;
  resourceCategories: string;
  createdFrom?: string;
  orderBy: string | string[];
  categories: string | string[];
};

type ResourcesQueryData = {
  resources: {
    edges: Array<{
      node: ResourceProps;
    }>;
  };
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100px;
  @media (min-width: 768px) {
    width: 90%;
    margin: 0 auto;
  }
  @media (min-width: 1140px) {
    width: 1024px;
  }
  .mobileWrapper {
    width: 90%;
    margin: 0 auto 15px;
    @media (min-width: 768px) {
      width: 100%;
      margin: 0 0 15px;
    }
    .title {
      font-family: Poppins, Arial, sans-serif;
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 15px;
    }
  }
  .cardsWrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .singleCard {
      width: 100%;
      @media (min-width: 768px) {
        width: calc(calc(100% - 24px) / 2);
        margin-right: 24px;
        &:nth-child(2) {
          margin-right: 0;
        }
      }
      @media (min-width: 1024px) {
        width: calc(calc(100% - 48px) / 3);
        margin-right: 24px;
        &:nth-child(2) {
          margin-right: 24px;
        }
        &:nth-child(3) {
          margin-right: 0;
        }
      }
    }
  }
`;

const countryPrefix = getCountryPrefix();

const RelatedContent = ({
  category,
  resourceCategory,
}: RelatedContentProps) => {
  const { me: user } = useMe();
  const otherCategories = ['herramientas', 'tutoriales', 'ebooks'].filter(
    c => c !== category,
  );
  const isUserPremium =
    user && (user.isPremiumMember || user.hasOrganization || user.isStaff);
  const { t } = useTranslation();
  const isBrazil = useIsBrazil();
  const [showLeadSection, setShowLeadSection] = React.useState(
    !isUserPremium && !isBrazil,
  );

  return (
    <Query<ResourcesQueryData, ResourcesQueryVariables>
      query={ResourcesQuery}
      variables={{
        first: 3,
        orderBy: category === 'tutoriales' ? '-downloads' : '-views',
        resourceCategories: !resourceCategory ? '' : resourceCategory.slug,
        categories: otherCategories.join(','),
      }}
    >
      {({ loading, data }) => (
        <>
          {showLeadSection && (
            <GetLeadSection
              showFormRegister={Boolean(user)}
              hideSection={() => setShowLeadSection(false)}
              countryPrefix={countryPrefix}
            />
          )}

          <Wrapper>
            {loading || !data ? null : transformData(data.resources).length ? (
              <div style={{ marginTop: '40px' }}>
                <div className="mobileWrapper">
                  <T bold className="title">
                    {t('RELATED_CONTENT', {
                      defaultValue:
                        localesEs.es['resource-detail'].RELATED_CONTENT,
                    })}
                  </T>
                </div>
                <div className="cardsWrapper">
                  {transformData(data!.resources).map(c => (
                    <div className="singleCard" key={c.originalId}>
                      <ResourceCard {...c} resourceDetail />
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </Wrapper>
        </>
      )}
    </Query>
  );
};

export default RelatedContent;
